import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  uploadMsdsTitle: {
    defaultMessage: 'Upload Material Safety Data Sheet (MSDS)',
    description: 'Title for MSDS upload section',
    id: 'YNhZQ5',
  },
  removeButton: {
    defaultMessage: 'Remove',
    description: 'Button text for removing file',
    id: 'VafT/Z',
  },
  uploadError: {
    defaultMessage: 'Failed to upload file. Please try again.',
    description: 'Error message when MSDS file upload fails',
    id: 'YG8Piu',
  },
  downloadError: {
    defaultMessage: 'Failed to download file. Please try again.',
    description: 'Error message when MSDS file download fails',
    id: 't/ZxYI',
  },
  removeError: {
    defaultMessage: 'Failed to remove file. Please try again.',
    description: 'Error message when MSDS file removal fails',
    id: 'uYD5qb',
  },
});
